import { LOCALE_VALUES } from '@/util/i18n/locale';

// Get the first locale that we support
export function getSupportedLocale(locales = []) {
  return findLocale(locales) || findLocaleByLanguage(locales);
}

// Find the first locale that we support
export function findLocale(locales = []) {
  return locales.find((x) => LOCALE_VALUES.includes(x));
}

// Find the first locale that has a languageCode that we support
// i.e ['es-ES', 'en-GB'] -> 'en-CA'
export function findLocaleByLanguage(locales = []) {
  let result;

  locales.some((x) => {
    result = LOCALE_VALUES.find((y) => x.substr(0, 2) === y.substr(0, 2));

    return result !== undefined;
  });

  return result;
}
